import { UseQueryOptions } from '@tanstack/react-query';
import {
	DashboardConfig,
	DashboardConfigRequest,
	DashboardControllerPath,
	DashboardDataResult,
	DashboardNodeRequest,
	GetDashboardConfigRequestPath,
	GetDashboardDataRequestPath,
	scopedClientKey,
	scopedProjectKey,
	urlCombine,
} from 'ihub/common';
import {
	coreAPI,
	getTenantID,
	isURLSet,
	standardPost,
	validateOkResponse,
} from '../classes/http-helper-const';
import { cacheStaleTime } from '../constants';

export class DashboardHttpService {
	getDashboardConfigQuery(
		dashboardConfigRequest: DashboardConfigRequest
	): UseQueryOptions<DashboardConfig, unknown, DashboardConfig> {
		let prefix = '';
		let additionalHeaders: HeadersInit | undefined;
		if (dashboardConfigRequest.contextType) {
			const isClient = dashboardConfigRequest.contextType === 'clientSpace';

			additionalHeaders = {
				[isClient ? scopedClientKey : scopedProjectKey]: dashboardConfigRequest.contextID,
			};
			prefix = isClient ? 'Client' : 'Project';
		}

		return {
			queryKey: [getTenantID(), 'dashboard-config', dashboardConfigRequest.contextID],
			queryFn: async (): Promise<DashboardConfig> => {
				isURLSet();
				const url = urlCombine(
					coreAPI,
					DashboardControllerPath,
					prefix,
					GetDashboardConfigRequestPath
				);
				const res = await standardPost(url, dashboardConfigRequest, additionalHeaders);
				await validateOkResponse(res, 'post', 'Dashboard Config');
				return await res.clone().json();
			},
			staleTime: cacheStaleTime,
		};
	}

	getDashboardNodeDataQuery(
		dashboardDataRequest: DashboardNodeRequest
	): UseQueryOptions<DashboardDataResult, unknown, DashboardDataResult> {
		return {
			queryKey: [
				getTenantID(),
				'dashboard-data',
				dashboardDataRequest.dashboardConfigID,
				dashboardDataRequest.dashboardNodeID,
				JSON.stringify(dashboardDataRequest.dashboardTimeSpan),
			],
			queryFn: async (): Promise<DashboardDataResult> => {
				isURLSet();
				const url = urlCombine(coreAPI, DashboardControllerPath, GetDashboardDataRequestPath);
				const res = await standardPost(url, dashboardDataRequest);
				await validateOkResponse(res, 'post', 'Dashboard Data');
				return await res.clone().json();
			},
			staleTime: cacheStaleTime,
		};
	}
}
